// extracted by mini-css-extract-plugin
export default {"container":"LayoutVariants_container__hgxBh","actionButton":"LayoutVariants_actionButton__U1mpZ"};